import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CenteredPanel } from '@/shared/feedback/CenteredPanel.tsx'
import { CardView } from '../CardView/CardView.tsx'
import { useCard } from '../hooks/index.ts'

/** `/audits/:auditId/cards/:cardId` — where evidence becomes visible (§10.2). */
export function CardPage() {
  const { t } = useTranslation()
  const { auditId, cardId } = useParams<{ auditId: string; cardId: string }>()
  const { page, error, isLoading, refresh } = useCard(auditId, cardId)
  if (isLoading || !auditId) {
    return (
      <CenteredPanel
        title={t('pages.audits.card.loading', { defaultValue: 'Loading the card…' })}
        muted
      />
    )
  }
  if (error || page === null) {
    return (
      <CenteredPanel
        title={t('pages.audits.card.error', { defaultValue: 'Could not load the card' })}
        meta={
          error && error.status !== null ? `HTTP ${error.status} · ${error.message}` : undefined
        }
        tone="error"
      />
    )
  }
  return <CardView auditId={auditId} page={page} refresh={refresh} />
}
